import { DecimalPipe } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Component, Input, SimpleChanges } from '@angular/core';
import { Helper, getRandomColorWithOpacity } from '@piqet-angular/data';
import { commonEnum, ImpactDataFormateEnum, reportTitals } from '@piqet-angular/shared';
import { Chart, ChartOptions } from 'chart.js';

@Component({
  selector: 'piqet-angular-life-cycle-impact-chart',
  templateUrl: './life-cycle-impact-chart.component.html',
  styleUrls: ['./life-cycle-impact-chart.component.scss'],
})
export class LifeCycleImpactChartComponent {
  chartOpacity: any = { value: commonEnum.opacity };
  @Input() SpiderChartItems: any;
  reportResource = reportTitals;
  spiderChartItemsData: any;
  tableId: number = 3;
  imagelist = [];
  interpretedText: any;
  indicatornamelist = [];
  indicatorunitnamelist = [];
  x = 5;
  tempArr: any = [];
  tempArrSavingPercentage: any = [];
  spiderChartLabels: string[] = [];
  chartImage: any;
  spiderChartData: any = [];
  @Input() isFullReport: any = false;
  componentItemsArray: any;
  componentItems: any;
  parentArr: any;
  lblEquivalancyUnitsTableId: any;
  lblLifeCycleImpactScenarioTableId: any;
  lblLifeCycleImpactAnnumTableId: any;
  background: any;
  constructor(private http: HttpClient, private decimalPipe: DecimalPipe, private helper: Helper) {}

  ngOnInit() {}

  setTableId() {
    //If there's any change in sequence/number of the sections in html then th sequence/number of these variable also has to be changed.
    this.lblEquivalancyUnitsTableId = this.spiderChartItemsData?.additionalElements
      .toLowerCase()
      .includes('4')
      ? this.tableId + 1
      : this.tableId;
    this.lblLifeCycleImpactScenarioTableId = this.lblEquivalancyUnitsTableId + 1;
    this.lblLifeCycleImpactAnnumTableId = this.lblLifeCycleImpactScenarioTableId + 1;
  }

  ngOnChanges(changes: SimpleChanges) {
    if (!!changes['SpiderChartItems']?.currentValue) {
      this.spiderChartItemsData = changes['SpiderChartItems'].currentValue;
    }
    this.setTableId();
    const projectInterpretation = this.spiderChartItemsData.projectInterpretation;
    this.chartOpacity = { value: this.spiderChartItemsData?.opacity };
    this.interpretedText = this.formatText(projectInterpretation);
    if (this.spiderChartItemsData.scenarioListForAnnumImpact.length > 0) {
      this.imagelist = !!this.spiderChartItemsData.scenarioListForAnnumImpact[0]
        .indicatorImageNameTable
        ? this.spiderChartItemsData.scenarioListForAnnumImpact[0].indicatorImageNameTable.split(';')
        : [];
      this.indicatornamelist = !!this.spiderChartItemsData.scenarioListForAnnumImpact[0].indicators
        ? this.spiderChartItemsData.scenarioListForAnnumImpact[0].indicators.split(';')
        : [];
      this.indicatorunitnamelist = !!this.spiderChartItemsData.scenarioListForAnnumImpact[0]
        .indicatorUnitName
        ? this.spiderChartItemsData.scenarioListForAnnumImpact[0].indicatorUnitName.split(';')
        : [];
      this.arrayFunction();
    }
    this.componentItemsArray = this.spiderChartItemsData.scenarioList;
  }

  formatText(text: string): string {
    if (!text) return '';
    let formattedText = text.replace(/(?<!>)\n(?!\s*<)/g, '<br>');
    formattedText = formattedText.replace(/<\s*h[1-6]\b[^>]*>(.*?)<\s*\/\s*h[1-6]>/gi, '<p>$1</p>');
    return formattedText;
  }

  getRange(x: number): number[] {
    return Array.from({ length: x }, (_, index) => index);
  }

  getReturnLength(data: any) {
    return data?.split(';').length;
  }

  arrayFunction() {
    for (let i = 0; i < this.spiderChartItemsData.scenarioListForAnnumImpact.length; i++) {
      this.tempArr.push(
        this.spiderChartItemsData.scenarioListForAnnumImpact[i]?.totals?.split(';')
      );
      this.tempArrSavingPercentage.push(
        this.spiderChartItemsData.scenarioListForAnnumImpact[i]?.savingPercentage?.split(';')
      );
    }
  }

  getMulti(x: any, y: any) {
    return (Number(x) * y).toString();
  }

  splitterFunc(input: any) {
    return input.includes(';') ? input.split(';') : [input];
  }

  toTitleCase(str: any) {
    return str.replace(/\w\S*/g, (txt: any) => {
      return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    });
  }
}
